"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Point = _interopRequireDefault(require("./Point"));

var _Vector = _interopRequireDefault(require("./Vector"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

/**
 * @param {Point} center
 * @param {Point} a
 * @param {Point} b
 * @returns {number}
 */
var comparePointsCounterClockwise = function comparePointsCounterClockwise(center, a, b) {
  var angleToA = a.getAngleFromOrigin(center);
  var angleToB = b.getAngleFromOrigin(center);
  if (angleToA < angleToB) return -1;
  if (angleToB < angleToA) return 1;
  return 0;
};

var Polygon = /*#__PURE__*/function () {
  /** @private {Point} */

  /** @private {Number} */

  /** @private {Number} */

  /** @private {Number} */

  /** @private {Number} */

  /** @private {Array<Point>} */
  function Polygon(points) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Polygon);
    (0, _defineProperty2["default"])(this, "_centerPoint", void 0);
    (0, _defineProperty2["default"])(this, "_maxX", void 0);
    (0, _defineProperty2["default"])(this, "_maxY", void 0);
    (0, _defineProperty2["default"])(this, "_minX", void 0);
    (0, _defineProperty2["default"])(this, "_minY", void 0);
    (0, _defineProperty2["default"])(this, "_points", void 0);

    /** @type {number} */
    var sumX = 0;
    /** @type {number} */

    var sumY = 0; // Calculate centroid.

    points.forEach(function (point) {
      var x = point.x,
          y = point.y;
      sumX += x;
      sumY += y; // set max and min of all the points

      if (!(0, _isNumber["default"])(_this._maxX) || _this._maxX < x) {
        _this._maxX = x;
      }

      if (!(0, _isNumber["default"])(_this._minX) || _this._minX > x) {
        _this._minX = x;
      }

      if (!(0, _isNumber["default"])(_this._maxY) || _this._maxY < y) {
        _this._maxY = y;
      }

      if (!(0, _isNumber["default"])(_this._minY) || _this._minY > y) {
        _this._minY = y;
      }
    });
    this._centerPoint = new _Point["default"](Math.round(sumX / points.length), Math.round(sumY / points.length)); // Points must be ordered counter-clockwise to support Sutherland-Hodgman clipping.

    this._points = points.sort(function (a, b) {
      return comparePointsCounterClockwise(_this.center, a, b);
    });
  }
  /** @returns {Point} */


  (0, _createClass2["default"])(Polygon, [{
    key: "getClippedWith",

    /**
     * Uses Sutherland-Hodgman algorithm to get the intersection of the subject polygon (this) and the given clipping
     * polygon. This specific implementation is based on the pseudo code here:
     *
     * https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm#Pseudo_code
     *
     * This implementation assumes:
     *  1 - The vertices of the polygon should be sorted counter-clockwise from its center.
     *  2 - The subject polygon (this) && the given clipping polygon are both convex.
     *
     * @param {Polygon} clippingPolygon
     * @returns {Polygon}
     */
    value: function getClippedWith(clippingPolygon) {
      // Start with all points in the subject polygon.

      /** @type {Array<Point>} */
      var output = this.points; // Use the last vertex in the clipping polygon as the start for our first clip edge.

      /** @type {Point} */

      var clipEdgeStart = clippingPolygon.points[clippingPolygon.points.length - 1]; // For each edge in the clipping polygon, where an edge is represented by two adjacent, counter-clockwise vertices:

      for (var j = 0; j < clippingPolygon.points.length; j++) {
        /** @type {Point} */
        var clipEdgeEnd = clippingPolygon.points[j];
        /** @type {Vector} */

        var clipEdge = new _Vector["default"](clipEdgeStart, clipEdgeEnd);
        /** @type {Array<Point>} */

        var input = output; // Clear output array.

        /** @type {Array<Point>} */

        output = [];
        /** @type {Point} */

        var myEdgeStart = input[input.length - 1];

        for (var i = 0; i < input.length; i++) {
          /** @type {Point} */
          var myEdgeEnd = input[i];
          /** @type {Vector} */

          var myEdge = new _Vector["default"](myEdgeStart, myEdgeEnd);

          if (clipEdge.isRightOfPoint(myEdgeEnd)) {
            if (!clipEdge.isRightOfPoint(myEdgeStart)) {
              output.push(clipEdge.getIntersectionPoint(myEdge));
            }

            output.push(myEdgeEnd);
          } else if (clipEdge.isRightOfPoint(myEdgeStart)) {
            output.push(clipEdge.getIntersectionPoint(myEdge));
          } // Start the my next edge at my previous edge's end.

          /** @type {Point} */


          myEdgeStart = myEdgeEnd;
        } // Start the next clip edge at the previous clip edge's end.

        /** @type {Point} */


        clipEdgeStart = clipEdgeEnd;
      }

      return new Polygon(output);
    }
  }, {
    key: "hasPointInside",
    value: function hasPointInside(point) {
      // ray-casting algorithm based on
      // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
      // found here https://github.com/substack/point-in-polygon
      var x = point.x,
          y = point.y;
      var inside = false;
      var polygonPoints = this.points;

      for (var i = 0, j = polygonPoints.length - 1; i < polygonPoints.length; j = i++) {
        var xi = polygonPoints[i].x;
        var yi = polygonPoints[i].y;
        var xj = polygonPoints[j].x;
        var yj = polygonPoints[j].y;
        var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    }
  }, {
    key: "center",
    get: function get() {
      return this._centerPoint;
    }
    /** @returns {Number} */

  }, {
    key: "maxX",
    get: function get() {
      return this._maxX;
    }
    /** @returns {Number} */

  }, {
    key: "maxY",
    get: function get() {
      return this._maxY;
    }
    /** @returns {Number} */

  }, {
    key: "minX",
    get: function get() {
      return this._minX;
    }
    /** @returns {Number} */

  }, {
    key: "minY",
    get: function get() {
      return this._minY;
    }
    /** @returns {Array<Point>} */

  }, {
    key: "points",
    get: function get() {
      return this._points;
    }
  }]);
  return Polygon;
}();

exports["default"] = Polygon;